<template>
  <div class="container-event-posts">
    <div style="display: flex; align-items: center">
      <span class="event-posts-title"> Eventos relevantes</span>
      <Badge
        v-if="!isSearching && events.length > 0"
        :value="events.length"
        :title="buildTitle()"
        style="cursor: pointer"
        class="ml-2"
      ></Badge>
    </div>
    <span v-if="this.days > 0" class="event-posts-subtitle">
      Nos próximos {{ this.days }} dias</span
    >
    <CustomSkeleton v-if="isSearching" type="card" :count="3" />
    <div v-if="!isSearching" class="content-event-posts">
      <span v-if="events.length === 0 && !isSearching" class="no-data-text"
        >Não há eventos nessa data.</span
      >
      <div v-for="event in events" :key="event.id">
        <CardEvent :event="event" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from '@/Shared/CustomSkeleton'
import CardEvent from './Components/CardEvent'
import Badge from 'primevue/badge'

export default {
  components: {
    CustomSkeleton,
    CardEvent,
    Badge,
  },
  props: {
    events: Array,
    isSearching: Boolean,
    days: Number,
  },
  methods: {
    buildTitle() {
      return `Total de eventos no período selecionado: ${this.events.length}`
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
